@use '@/styles/tokens' as *;

.fields {
  display: flex;
  flex-direction: column;
  gap: var(--space-6);
}

.field {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
}

.label {
  padding-inline: var(--space-2);
  font-size: $font-size-md;
  font-weight: var(--font-weight-regular);
  color: var(--text-secondary);
}

.footerLeft {
  display: flex;
  gap: var(--space-4);
}
